module.exports = "query GetPlans {\n  plans {\n    ...PlanFragment\n  }\n}\n"